import type { CharacterLanguage } from './character-labels';
const poles: Record<string, { ru: readonly [string, string]; en: readonly [string, string] }> = {
  compassion: { ru: ['Равнодушный', 'Сострадательный'], en: ['Indifferent', 'Compassionate'] },
  greed: { ru: ['Бескорыстный', 'Корыстный'], en: ['Selfless', 'Greedy'] },
  courage: { ru: ['Осторожный', 'Смелый'], en: ['Cautious', 'Brave'] },
  temper: { ru: ['Спокойный', 'Вспыльчивый'], en: ['Calm', 'Hot-tempered'] },
  sociability: { ru: ['Замкнутый', 'Общительный'], en: ['Reserved', 'Sociable'] },
  conscientiousness: { ru: ['Беззаботный', 'Добросовестный'], en: ['Carefree', 'Conscientious'] },
  independence: { ru: ['Ведомый', 'Самостоятельный'], en: ['Guided', 'Independent'] },
  pride: { ru: ['Скромный', 'Гордый'], en: ['Modest', 'Proud'] },
  awareness: { ru: ['Не замечает', 'Осознаёт'], en: ['Unaware', 'Aware'] },
  connection: { ru: ['Слабая связь', 'Тесная связь'], en: ['Distant', 'Connected'] },
  trust: { ru: ['Недоверие', 'Доверие'], en: ['Distrust', 'Trust'] },
  belief: { ru: ['Сомневается', 'Убеждён'], en: ['Uncertain', 'Convinced'] },
};
export function characterPoles(language: CharacterLanguage, id: string): readonly [string, string] {
  return (poles[id] ?? poles.belief!)[language];
}
